import React from 'react';

import { UniversityProfileLayout } from './UniversityProfileLayout'

const UniversityProfileContainer: React.FC = () => {

	return (
		<React.Fragment>
			<UniversityProfileLayout />
		</React.Fragment>
	);
};

export default UniversityProfileContainer;